// extracted by mini-css-extract-plugin
export default {"heading":"VOpVG2","desktopOnly":"TCCGgj"};